import { ChangeDetectionStrategy, Component } from '@angular/core';

/**
 * Autoscaling in one scene: demand rises and falls, Fleet adds and removes
 * instances underneath it, a spare rides along, all inside the band between
 * minimum and maximum.
 *
 * Inline SVG with CSS keyframes rather than a video or a GIF: a few kilobytes,
 * sharp on any display, coloured from the theme so it sits in light and dark,
 * and able to hold still when the reader asks for reduced motion.
 */
@Component({
  selector: 'autoscaling-visual',
  standalone: true,
  templateUrl: './autoscaling-visual.component.html',
  styleUrl: './autoscaling-visual.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AutoscalingVisualComponent {}
